// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: sans-serif;
  background-color: #f0f0f0;
  color: #000;
}

h1, h2, h3, h4, h5, h6,
p, ul, ol, li, a, u, b, i, span {
  all: unset;
  display: revert;
}

ul, ol {
  list-style: none;
}

button {
  all: unset;
  cursor: pointer;
}

input, textarea {
  all: unset;
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/reset.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  height: 100%;\n  font-family: sans-serif;\n  background-color: #f0f0f0;\n  color: #000;\n}\n\nh1, h2, h3, h4, h5, h6,\np, ul, ol, li, a, u, b, i, span {\n  all: unset;\n  display: revert;\n}\n\nul, ol {\n  list-style: none;\n}\n\nbutton {\n  all: unset;\n  cursor: pointer;\n}\n\ninput, textarea {\n  all: unset;\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
